<template>
    <div class="wrapper-lg border-top">
        <div class="col-lg-66 col-padding right" id="app">
            <h2><span>Zoeken in alle data</span></h2>
            <div class="search-all">
                <div class="vacancy-search-form search-form">
                    <div class="search-input">
                        <input class="form-control form-lg form-block course-search" type="text" v-model="filter.search" placeholder="Zoek op opleiding">
                    </div>
                    <div class="search-distance">
                        <input v-model.lazy="filter.near" placeholder="Plaats" class="form-control form-lg form-block" :class="{error: errors.near || errors.location}">
                        <select v-model="filter.radius" class="form-control form-lg form-block">
                            <option v-for="radius of [10, 15, 25, 50]" :key="radius" :value="radius+'km'">{{ radius }} km</option>
                        </select>
                    </div>
                    <div>
                        <button class="btn btn-primary btn-inline btn-lg">Zoeken</button>
                    </div>
                </div>
            </div>

            <div class="vacancies-overview">
                <FullCalendar ref="fullCalendar" :options="calendarOptions"></FullCalendar>
            </div>
        </div>

        <div class="col-lg-33 col-padding">
            <div class="main-filter-vacancies">
                <i class="icon icon-cross"></i>
                <h2 class="color-tertiary">Filter</h2>
                <div class="filter-block">
                    <h5 class="color-tertiary">Thema's</h5>
                    <div class="border"></div>
                    <ul class="grid">
                        <li v-for="theme of themes">
                            <label class="checkbox-parent">
                                <input type="checkbox" v-model="filter.theme" :value="theme['id']"
                                       class="form-auto-submit check-control">
                                <div class="checkbox-placeholder form-sm"></div>
                                {{theme['title']}}
                            </label>
                        </li>
                    </ul>
                </div>

                <div class="filter-block">
                    <h5 class="color-tertiary">Periode</h5>

                    <div class="border"></div>

                    <ul class="grid">
                        <li v-for="range of ranges" :key="range.id">
                            <label class="checkbox-parent">
                                <input type="radio" v-model="filter.range" :value="range.id" class="form-auto-submit">

                                {{range.name}}
                            </label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FullCalendar from '@fullcalendar/vue';
    import listPlugin from '@fullcalendar/list';
    import nlLocale from '@fullcalendar/core/locales/nl';

    export default {
        name: "Calendar",
        components: {
            FullCalendar
        },
        data() {
            self = this;
            return {
                themes: [],
                events: [],
                filter: {
                    search: null,
                    near: '',
                    radius: '10km',
                    theme: [],
                    range: '',
                },
                calendarOptions: {
                    plugins: [listPlugin],
                    initialView: 'listWeek',
                    headerToolbar: {
                        start: 'title',
                        center: '',
                        end: 'today prev,next'
                    },
                    firstDay: 1,
                    locale: nlLocale,
                    events: [],
                    eventDidMount(info) {
                        let element = info.el;

                        const items = info.event.title.match(/.{1,35}/g);
                        const title = items.join('<br />');

                        element.querySelector('.fc-list-event-time').innerHTML = `<strong>${title}</strong>`;
                        element.querySelector('.fc-list-event-time').style.width = '15%';
                        element.querySelector('.fc-list-event-graphic').innerHTML = self.events[info.event.id].location;
                        element.querySelector('.fc-list-event-graphic').style.width = '15%';
                        element.querySelector('.fc-list-event-title').innerHTML = self.events[info.event.id].spots_available;
                        element.querySelector('.fc-list-event-title').style.width = '40%';

                        let td = document.createElement('td');
                        td.style.width = '20%';
                        let button = document.createElement('a');
                        button.href = self.events[info.event.id].reservation_url;
                        button.classList.add('btn', 'btn-primary', 'btn-block', 'btn-narrow');
                        let span = document.createElement('span');
                        span.classList.add('text-xs');
                        span.textContent = 'Reserveer jouw plek »';
                        button.appendChild(span);
                        td.appendChild(button);

                        document.querySelectorAll('.fc-list-day').forEach(item => {
                            item.childNodes[0].colSpan = 4;
                        });

                        element.appendChild(td);
                    },
                },

                ranges: [
                    { id: '', name: 'Deze week (ma t/m zo)' },
                    { id: 'within_two_weeks', name: 'Binnen 2 weken' },
                    { id: 'within_four_weeks', name: 'Binnen 4 weken' },
                    { id: 'next_month', name: 'Volgende maand' },
                    { id: 'next_three_months', name: 'Komende 3 maanden' },
                    { id: 'next_six_months', name: 'Komend half jaar' },
                ],

                errors: {},

                preventGetEventsReTrigger: false
            }
        },
        watch: {
            filter: {
                handler: 'getEvents',
                deep: true
            }
        },
        methods: {
            getEvents() {
                if (this.preventGetEventsReTrigger) {
                    this.preventGetEventsReTrigger = false;

                    return;
                }

                this.errors = {};

                let urlItems = [];
                for (let item in this.filter) {
                    let value = this.filter[item];

                    if (value === null || value === '' || value.length === 0) {
                        continue;
                    }

                    urlItems.push(item + '=' + value);
                }

                axios.get('ajax/get-events?' + urlItems.join('&'))
                    .catch(error => {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;

                            return;
                        }

                        throw error;
                    })
                    .then(response => {
                        if (response.data.near != null && response.data.near !== this.filter.near) {
                            this.preventGetEventsReTrigger = true;
                            this.filter.near = response.data.near;
                        }

                        if (response.data.range != null) {
                            this.$refs.fullCalendar.getApi().changeView('list', { start: response.data.range[0], end: response.data.range[1] });

                            this.$refs.fullCalendar.getApi().setOption('headerToolbar', {
                                start: 'title',
                                center: '',
                                end: '',
                            });
                        } else {
                            this.$refs.fullCalendar.getApi().changeView('listWeek');

                            this.$refs.fullCalendar.getApi().setOption('headerToolbar', {
                                start: 'title',
                                center: '',
                                end: 'today prev,next',
                            });
                        }

                        this.events = response.data.events;
                        this.calendarOptions.events = response.data.calendar;
                    });
            }
        },
        mounted() {
            axios.get('ajax/get-agenda')
                .then(response => {
                    this.themes = response.data.themes;
                });

            this.getEvents();
        }
    }
</script>

<style scoped>

</style>
